import http from '../../../lib/http';

export const FETCH_BAR_REPORT_TRANSACTIONS_START = 'FETCH_BAR_REPORT_TRANSACTIONS_START';
export const FETCH_BAR_REPORT_TRANSACTIONS_ERROR = 'FETCH_BAR_REPORT_TRANSACTIONS_ERROR';
export const FETCH_BAR_REPORT_TRANSACTIONS_SUCCESS = 'FETCH_BAR_REPORT_TRANSACTIONS_SUCCESS';

export const DELETE_BAR_REPORT_TRANSACTION_START = 'DELETE_BAR_REPORT_TRANSACTION_START';
export const DELETE_BAR_REPORT_TRANSACTION_ERROR = 'DELETE_BAR_REPORT_TRANSACTION_ERROR';
export const DELETE_BAR_REPORT_TRANSACTION_SUCCESS = 'DELETE_BAR_REPORT_TRANSACTION_SUCCESS';

export const ADD_BAR_REPORT_TRANSACTION_START = 'ADD_BAR_REPORT_TRANSACTION_START';
export const ADD_BAR_REPORT_TRANSACTION_ERROR = 'ADD_BAR_REPORT_TRANSACTION_ERROR';
export const ADD_BAR_REPORT_TRANSACTION_SUCCESS = 'ADD_BAR_REPORT_TRANSACTION_SUCCESS';

export const CLEAR_BAR_REPORT_TRANSACTIONS = 'CLEAR_BAR_REPORT_TRANSACTIONS';
export const BAR_REPORT_TRANSACTION_TYPE = 'BAR_REPORT_TRANSACTION_TYPE';
export const BAR_REPORT_TRANSACTION_VISIBLE_FORM = 'BAR_REPORT_TRANSACTION_VISIBLE_FORM';

export function clearBarReportTransactions() {
    return {
        type: CLEAR_BAR_REPORT_TRANSACTIONS
    }
}

export function setReportTransactionVisibleForm(visible) {
    return {
        type: BAR_REPORT_TRANSACTION_VISIBLE_FORM,
        payload: {visible}
    }
}

export function setReportTransactionType(type) {
    return {
        type: BAR_REPORT_TRANSACTION_TYPE,
        payload: {type}
    }
}

export function deleteBarReport(transactionId, barId, limit, page) {
    return {
        type: 'DELETE_BAR_REPORT_TRANSACTION',
        payload: {
            promise: delBarReportTransaction(transactionId, barId, limit, page)
        }
    };
}

export function fetchBarReportTransactions(barId, limit, page) {
    return {
        type: 'FETCH_BAR_REPORT_TRANSACTIONS',
        payload: {
            promise: getBarReportTransactions(barId, limit, page)
        }
    };
}

export function createBarReportTransactions(fields, type, barId, limit, page) {
    return {
        type: 'ADD_BAR_REPORT_TRANSACTION',
        payload: {
            promise: addBarReportTransactions(fields, type, barId, limit, page)
        }
    };
}

async function addBarReportTransactions(fields, type, barId, limit, page) {
    const res = await http.post(`/app/transactions/${type.toLowerCase()}/ ${barId}/${limit}/${page}`, {body: fields});
    if (res.status < 300) return res.json();
    throw res;
}

async function getBarReportTransactions(barId, limit, page) {
    const res = await http.get(`/app/transactions/list/${barId}/${limit}/${page}`);
    if (res.status < 300) return res.json();
    throw res;
}

async function delBarReportTransaction(transactionId, barId, limit, page) {
    const res = await http.delete(`/app/transactions/delete/${transactionId}/${barId}/${limit}/${page}`);
    if (res.status < 300) return res.json();
    throw res;
}


// WEBPACK FOOTER //
// ./src/common/menu/report/transaction/actions.js